import * as actionType from '../actionTypes';

const initialState = {
    switchApiData: {}
}

const switchApiReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.SWITCH_API_DATA: 
        return {
            ...state,
            switchApiData: action.payload
        }
        default:
            return state
    }
}

export default switchApiReducer